let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5S6FQ")).then(() => parcelRequire('gD4kC'));